import { render, staticRenderFns } from "./Greeting.vue?vue&type=template&id=1482fdac&scoped=true&"
import script from "./Greeting.vue?vue&type=script&lang=js&"
export * from "./Greeting.vue?vue&type=script&lang=js&"
import style0 from "./Greeting.vue?vue&type=style&index=0&id=1482fdac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1482fdac",
  null
  
)

export default component.exports